/**
 * @generated SignedSource<<10c5ba417eb6b16c1f89ba0296285d56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type UserAppsRouterQuery$variables = {
  skipMe: boolean;
  skipUser: boolean;
  userId: string;
};
export type UserAppsRouterQuery$data = {
  readonly viewer: {
    readonly me?: {
      readonly hasDedicatedApp: boolean;
      readonly id: string;
    } | null;
    readonly user?: {
      readonly hasDedicatedApp: boolean;
      readonly id: string;
    } | null;
  };
};
export type UserAppsRouterQuery = {
  response: UserAppsRouterQuery$data;
  variables: UserAppsRouterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMe"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasDedicatedApp",
    "storageKey": null
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "condition": "skipMe",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "me",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "skipUser",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "userId"
              }
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAppsRouterQuery",
    "selections": (v4/*: any*/),
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "UserAppsRouterQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "7f0f37e189f3466b41476466c000e912",
    "id": null,
    "metadata": {},
    "name": "UserAppsRouterQuery",
    "operationKind": "query",
    "text": "query UserAppsRouterQuery(\n  $userId: ID!\n  $skipMe: Boolean!\n  $skipUser: Boolean!\n) {\n  viewer {\n    me @skip(if: $skipMe) {\n      id\n      hasDedicatedApp\n    }\n    user(id: $userId) @skip(if: $skipUser) {\n      id\n      hasDedicatedApp\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4ec65db1429a2d707ee840ad2e08194";

export default node;
